/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { ROUTES } from "../../constants/constants";
import ClientProfileForm from "../../components/client/ClientProfileForm";
import Container from "../../components/Container";
import NavigationHeader from "../../components/NavigationHeader";

const ClientProfile = () => {
  return (
    <Container>
      <NavigationHeader title="my_profile" back={ROUTES.HOME} />
      <ClientProfileForm />
    </Container>
  );
};

export default ClientProfile;
